// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"475b9de1","513":"b99e50ac","787":"87d6e067"}[chunkId] + ".chunk.js";
};